import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { device } from '../../styles/devices';
import { color } from '../../styles/mixins';
import { theme } from '../../styles/theme';

const Wrapper = styled.footer`
  background-color: #f6fbff; // lightBlue rgb(246, 251, 255) #f6fbff
  position: relative;
  z-index: 1;
`;

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: ${theme.breakpoints.lg.gutter / 2};
  padding-right: ${theme.breakpoints.lg.gutter / 2};
  min-height: auto;
  flex-grow: 1;
  max-width: ${theme.pageWidth + theme.breakpoints.lg.gutter};
`;

const Spacing = styled.div`
  padding-top: 13px;
  padding-bottom: 13px;

  @media ${device.tablet} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media ${device.desktop} {
    padding-top: 26px;
    padding-bottom: 26px;
  }
  @media ${device.pageLimit} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

const Row = styled.div`
  margin-left: ${theme.breakpoints.lg.gutter / -2};
  margin-right: ${theme.breakpoints.lg.gutter / -2};
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
`;

const Column = styled.div`
  flex: none;
  padding-left: ${theme.breakpoints.lg.gutter / 2}px;
  padding-right: ${theme.breakpoints.lg.gutter / 2}px;
  align-self: stretch;
  margin-left: 8.33333%;
  width: 83.3333%;

  @media ${device.tablet} {
    margin-left: 16.6667%;
    width: 66.6667%;
  }
`;

const Links = styled.div`
  margin: 0 auto;
  text-align: center;

  a {
    margin: 0 8px;
    white-space: nowrap;

    @media screen and (max-width: 768px) {
      display: block;
      margin-bottom: 8px;
    }
  }

  a:hover {
    color: ${color('blue60')};
  }
`;

const CopyRight = styled.div({
  marginTop: '24px',
  textAlign: 'center',
});

export const Footer = () => {
  const year = new Date().getFullYear();

  const location = useLocation();

  const isHidden = location.pathname === '/register';

  return (
    <Wrapper style={{ display: isHidden ? 'none' : 'block' }}>
      <Container>
        <Spacing>
          <Row>
            <Column>
              <Links>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </Links>
              <CopyRight>&copy; {year} Sotheby&lsquo;s</CopyRight>
            </Column>
          </Row>
        </Spacing>
      </Container>
    </Wrapper>
  );
};
